// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__KRo4a","icon":"style_icon___ACEe","textsContainer":"style_textsContainer__6_WTS"};